import { defineComponent as _defineComponent } from 'vue'
import WizardStep from '../wizard/WizardStep.vue';
import { Customer } from '@/models/tenant';
import { tenantsService } from '@/services/tenants.service';
import { computed, onMounted, ref } from 'vue';
import { isEmpty } from '@/utils/misc';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomersListSelectorWizardStep',
  props: {
    value: { default: () => [] }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((e: 'input', value: Customer[]) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { value: Customer[] };





const customers = ref<Customer[]>([]);

const loading = ref(false);

const { t, tc } = useI18n();

onMounted(() => {
  refreshCustomers();
});

async function refreshCustomers() {
  loading.value = true;
  try {
    customers.value = await tenantsService.get();
  } finally {
    loading.value = false;
  }
}

const selectedCustomers = computed({
  get() {
    return props.value;
  },
  set(newValue) {
    emit('input', newValue);
  },
});

const orderedCustomers = computed(() =>
  customers.value.sort((a, b) => {
    const aIsSelected = selectedCustomers.value.includes(a);
    const bIsSelected = selectedCustomers.value.includes(b);
    if (aIsSelected === bIsSelected) {
      return a.name.localeCompare(b.name);
    }
    return aIsSelected ? -1 : 1;
  }),
);

return { __sfc: true,props, emit, customers, loading, t, tc, refreshCustomers, selectedCustomers, orderedCustomers, WizardStep, isEmpty }
}

})